// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-active-parallel[data-v-315f1394] {\n  background-color: var(--primary);\n}\n.btn-active-parallel[data-v-315f1394]:active, .btn-active-parallel[data-v-315f1394]:focus {\n  background-color: var(--primary);\n  box-shadow: none;\n}\n.btn-transparent[data-v-315f1394] {\n  background-color: transparent;\n}\n.btn-transparent[data-v-315f1394]:active, .btn-transparent[data-v-315f1394]:focus {\n  background-color: transparent;\n  box-shadow: none;\n}", ""]);
// Exports
module.exports = exports;
